export const SCHOOLS_PATH = "/school";
export const QUESTIONS_PATH = "/questions";
export const CRUSHES_PATH = "/crush";
export const JOBS_PATH = "/job";
export const DISCOVER_PATH = "/discover";
export const NO_FOUND_PATH = "/404";
export const NOTIFICATIONS_PATH = "/notifications";
export const FEED_PATH = "/feed";
export const HOME_PATH = "/";
export const SEARCH_PATH = "/search";
export const SAVED_PATH = "/saved";
export const CONTACT_PATH = "/contact";
export const TERMS_PATH = "/terms";

export const READ_POST_PATH = "/post/:slug";
export const CREATE_POST_PATH = "/post/create";
export const EDIT_POST_PATH = "/post/edit/:slug";
export const PREVIEW_POST_PATH = "/post/preview";

export const PROFILE_PATH = "/profile/:user";
export const CURRENT_USER_PROFILE_PATH = "/me";
export const CURRENT_USER_PROFILE_COMMENTS_PATH = "/me?section=comments";
export const CURRENT_USER_PROFILE_GIFTS_PATH = "/me?section=gifts";
export const PROFILE_COMMENTS_PATH = "/profile/:user?section=comments";

export const SETTINGS_PATH = "/settings";
export const SETTINGS_PROFILE_PATH = "/settings/profile";
export const SETTINGS_SCHOOL_PATH = "/settings/school";
export const SETTINGS_PICTURE_PATH = "/settings/picture";
export const SETTINGS_COVER_PATH = "/settings/cover";
export const SETTINGS_PASSWORD_PATH = "/settings/password";
export const SETTINGS_NOTIFICATION_PATH = "/settings/notification";
export const SETTINGS_FACEBOOK_PATH = "/settings/facebook";
export const SETTINGS_CURRICULUM_PATH = "/settings/curriculum";

export const MESSAGES_PATH = "/messages";
export const CONVERSATION_PATH = "/messages/:conversation";

export const CHAT_PATH = "/chat";

export const SCHOOL_CREATE_PATH = "/school/create";
export const SCHOOL_READ_PATH = "/school/:school";
export const SCHOOL_EDIT_PATH = "/school/:school/edit";

export const TEACHER_READ_PATH = "/teacher/:teacher";

export const CRUSH_READ_PATH = "/crush/:crush";

export const JOB_CREATE_PATH = "/job/create";
export const JOB_READ_PATH = "/job/:job";
